export const environment = {
  municipio: 'goiania',
  production: true,
  isETopocartDev: false,
  isETopocartProd: false,
  isTopocart: false,
  isTopocartDev: false,
  isPortoVelho: false,
  isAlexania: false,
  isManaus: false,
  isGoiania: true,

  googleMapsKey: 'AIzaSyDa_RGUAd9-34P9bgA4181u_TPurVM-5FE',
  googleMapsAPI: 'https://maps.googleapis.com/maps/api/',
  /* Para ambientes onPremise é necessário a modificação da chave
  do reCAPTCHA, acesse https://www.google.com/recaptcha/admin
  com uma conta do dominio @topocart.com.br e crie uma chave para o dominio
do tipo v2/checkbox  que sera realizado o deploy */
  captchaKey: '6LcvkeAUAAAAAHy5Kofj78q5mntZFwHwL98KBFGI',
  googleGeoCodeAPI: 'https://maps.googleapis.com/maps/api/geocode/json',
  reportsUrl: 'https://apis-goiania.geo360.com.br/relatorios/',
  reportUrl: 'https://apis-goiania.geo360.com.br/relatorios/',

  visualizador360BaseUrl: 'https://visualizador-goiania.geo360.com.br',
  apiUrl: 'https://apis-goiania.geo360.com.br/plataforma/',
  conversorUrl: 'https://apis-goiania.geo360.com.br/conversor/',
  apiDjangoUrl: 'https://apis-goiania.geo360.com.br/plataforma/django/',
  apiDjangoDirectUrl: 'https://apis-goiania.geo360.com.br/cadastro/',
  apiUrlPostgrest: 'https://apis-goiania.geo360.com.br/gateway/rest',
  apiUrlGenericPostgrest: 'https://apis-goiania.geo360.com.br/gateway/plataforma/rest',
  apiUrlGenericPGTiles: 'https://apis-goiania.geo360.com.br/gateway/plataforma/tiles/',
  apiUrlPGTiles: 'https://apis-goiania.geo360.com.br/gateway/tiles/',
  djangoDirectUrlToken: 'Bearer bcf04b7e-b788-47eb-8bf1-a10f69d3a7e8',
  apiAttributesTable: 'https://apis-goiania.geo360.com.br/tabela-atributos',
  postgRestUrl: 'https://apis-goiania.geo360.com.br/gateway/rest',
  pgtilesUrl: 'https://apis-goiania.geo360.com.br/gateway/tiles/',
  caracterizacaoUrl: 'https://apis-goiania.geo360.com.br/caracterizacao',
  reportV2Url: 'https://apis-goiania.geo360.com.br/relatorios/',
  openRestUrl: 'https://apis-goiania.geo360.com.br/openrest/',
  apiCNAE:
    'https://cnae.criciuma.apps.etopocart.com/',

  // apiUrl: 'https://api4.appsgeo.io/' /* API Oficial */,
  geoServerUrl: 'https://mapsrv2.appsgeo.io/geoserver/',
  // apiUrl: 'https://staging-api.appsgeo.io/' /* API Staging */,
  geoServerWFSUrl:
    'https://mapsrv2.appsgeo.io/geoserver/wfs' /* GeoServer WFS */,
  photonApi: 'https://photon.komoot.de/api/' /* Photon API */,
  firebase: {
    apiKey: 'AIzaSyD4riPTBVU39qjL336AjXfdroCJwNUwQvg',
    authDomain: 'appsgeo-test.firebaseapp.com',
    databaseURL: 'https://appsgeo-test.firebaseio.com',
    projectId: 'appsgeo-test',
    storageBucket: 'appsgeo-test.appspot.com',
    messagingSenderId: '358703366933',
    appId: '1:358703366933:apps:27b8be17ee90f30ba35f1c',
  },
  recaptchaKey: '6LcvkeAUAAAAAHy5Kofj78q5mntZFwHwL98KBFGI',
  mapboxToken:
    'pk.eyJ1Ijoidm0ybWFwYm94IiwiYSI6ImNrbTF6MTYzczB6aGYybnIzcDY0eW9vb2sifQ.J9ErWF5EO5w3oLqGjzqi_w',
  apiGatewayUrl: 'https://apis-goiania.geo360.com.br/gateway/',
};
